import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { GetPartnerDetailData } from "@/types/partners";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getPartnerDetail = async (
  appSubdomain: string
): Promise<GetPartnerDetailData> => {
  try {
    const { data } = await axiosInstance.get(`/v1/partners/${appSubdomain}`);
    return data as GetPartnerDetailData;
  } catch (error) {
    const { status, message } = getErrorMessage(error);

    const newError = new CustomError(message, status);
    throw newError;
  }
};
